export function formatRanAt(ranAt: number | null): string {
  if (ranAt === null) {
    return 'Never run';
  }
  return `Last ran ${new Date(ranAt).toLocaleString()}`;
}
